import Controller from "../Engine/Controller";
import Engine from "../Engine/Engine";
import cfJS from "../Engine/cfJS";

/*
	Exemple:
	<button id="PushNotificationButton">test PushNotification</button>
	<script>
		window.addEventListener("DOMContentLoaded", function(){
			new PushNotification("PushNotificationButton",{
				action: "/",																						// string required
				event: "click",																					// string required
				serviceWorker: {																				// object required
					path: "serviceWorker.js", 																	// string required
					scope: "/" 																					// string no required
				},
				key: "BNNZihJZNQ1_lCkXMyX6OWEs7e1LXwzavv76RV7fxu1StYLm2Dr0eJ0d1nJOBOhmDCgFmiDY1c5DET5S-LFC6-k"	// string required
			})
		});
	</script>
 */

class PushNotification extends Controller {

    constructor(dom, options) {
    	// Checking for required parameters
    	if(typeof options !== "object"){
        	console.error(new Error("options must be an object!"));
        	return;
        }
        if(!options.action){
        	console.error(new Error("property 'action' in options absent!"));
        	return;
        }
        if(!options.event){
        	console.error(new Error("property 'event' in options absent!"));
        	return;
        }
        if(!options.serviceWorker){
        	console.error(new Error("property 'serviceWorker' in options absent!"));
        	return;
        }
        if(!options.serviceWorker.path){
        	console.error(new Error("property 'path' in options.serviceWorker absent!"));
        	return;
        }
        if(!options.key){
        	console.error(new Error("property 'key' in options absent!"));
        	return;
        }

        super(dom, "PushNotification");

        // Request link
        this.action = options.action;

        // The event on which the handler will be installed
        this.event = options.event;

        // Service worker parameters
        this.serviceWorkerOptions = {
            path: options.serviceWorker.path, 
            options: options.serviceWorker.scope ? {scope: options.serviceWorker.scope} : {}
        };

        // Push service subscription parameters
        this.subscribeOptions = {
          userVisibleOnly: true,
          applicationServerKey: options.key 
        };

        // Installing an event handler on an element
 		cfJS.addListener(this.domNode, this.event, (e) => {
            if(this.supportСheck()) {
            	this.requestPermission()
            	.then(() => {
            		this._subscribe();
            	})
            }
        });
    }

    /*
    	Checking for prerequisite support
     */
    supportСheck() {
        return ('serviceWorker' in navigator) && ('PushManager' in window) ? true : false; 
    }

	/*
		Request for permission to send push notifications
	 */
    requestPermission() {
        return new Promise((resolve, reject) => {
            const permissionResult = Notification.requestPermission((result) => {
              // Поддержка устаревшей версии с функцией обратного вызова.
                resolve(result);
            });
            if (permissionResult) {
                permissionResult.then(resolve, reject);
            }
        })
        .then((permissionResult) => {
            return new Promise((resolve, reject)=>{
            	permissionResult === 'granted' ? resolve() : reject();
            });
        });
    }

    /*
    	Subscription to the push notification service
     */
    _subscribe() {
    	const subscribe = (registration) => {
        	registration.pushManager.subscribe(this.subscribeOptions).then((data) => {
        		this._sendAjaxSubscribeData(data);
        	})
        };
        navigator.serviceWorker.register(this.serviceWorkerOptions.path, this.serviceWorkerOptions.options)
        .then((registration) => {
            let serviceWorker;
            if (registration.installing) {
                serviceWorker = registration.installing;
            } 
            else if (registration.waiting) {
                serviceWorker = registration.waiting;
            } 
            else if (registration.active) {
                serviceWorker = registration.active;
            }
            if (serviceWorker) {
                if (serviceWorker.state == "activated") {
                    subscribe(registration);
                }
                else {
                	serviceWorker.addEventListener("statechange", (e) => {
	                    if (e.target.state == "activated") {
	                        subscribe(registration);
	                    }
	                });
                }
            }
        })
        .catch((e) => {
        	console.error(new Error(e));
        })
    }

    // Sending customer data from a push service
    _sendAjaxSubscribeData(data) {
    	let dataJSON = "";
    	try {
    		dataJSON = JSON.stringify(data);
    	}
    	catch(e) {
    		console.error(new Error(e));
    	}
    	Engine.postRequest(this.action, {data: dataJSON}, (response) => {
    		console.log(response);
    	})
    }
}

window.PushNotification = PushNotification;